import React, { useCallback, useEffect, useRef, useState } from "react";
import Select from "react-select";
import FilterIcon from "../../assets/icons/filter-icon";
import AddButton from "../buttons/button";
import { capitalizeWords } from "../helper-components/helper-function";
import DatePickerInput from "../forms/date-picker";
import { debounce } from "lodash";
import SelectOption from "../helper-components/select-option";
import SearchIcon from "../../assets/icons/search-icon";
import excelImg from "../../assets/icons/excel.png";
import DownloadIcon from "../../assets/icons/download-icon";
import { PlusIcon, X } from "lucide-react";
import { useHotkeys } from "react-hotkeys-hook";
import { url } from "../../redux/config";
import { api, getCposUrl } from "../../redux/apis/api";
import successToast from "../helper-components/success-toast";
import errorToast from "../helper-components/error-toast";
import LoadingOverlay from "../helper-components/overlay-loading";

const FilterSection = ({
  filterData,
  setFilterData,
  initialFilter = {},
  addNew=false,
  newComponet=null,
  placeholder,
  filterFn = () => {},
  tableHeading,
  filterBy,
  showFilter,
  paginationProps,
  filterText = "Filter",
  date = true,
  filter,
  permissionFn,
  module,
  onclkFn,
  list,
  filterSec = true,
  newBtnTxt = "New",
  // SUB TABLE
  invoiceItems,
  handleSelect = () => {},
  options = [],
  importCsv = false,
  onclkCscDown = () => {},
  onclkCSV = () => {},
  fetchColumn,
  extraFilters=[ ],
  reload,
  setReload,
  beforeDateSlot = null,
}) => {
  const isLocalhost = typeof url === "string" && url.includes("localhost");
  const [searchTerm, setSearchTerm] = useState(filterData?.inputValue || "");
  const [soitId, setSoitId] = useState("");
  const [grnSyncLoading, setGrnSyncLoading] = useState(false);
  const newButtonRef = useRef();

  const handleGrnSync = async () => {
    const trimmed = soitId?.trim();
    if (!trimmed) {
      errorToast("Please enter a SOIT ID");
      return;
    }
    setGrnSyncLoading(true);
    try {
      const cposUrl = await getCposUrl()+'/api';
      if (!cposUrl) {
        return;
      }
      const { data } = await api.post("/run-grn-sync", {
        soit_id: trimmed,
        cposUrl,
      });
      if (data?.status === false) {
        errorToast(data?.message || "Failed to run GRN sync");
      } else {
        successToast(
          data?.message || `GRN synced successfully for SOIT ID ${trimmed}`
        );
        setSoitId("");
        if (typeof setReload === "function") {
          setReload(!reload);
        }
      }
    } catch (err) {
      const apiMsg =
        err?.response?.data?.message || err?.response?.data?.error;
      errorToast(apiMsg || err?.message || "Failed to run GRN sync");
    } finally {
      setGrnSyncLoading(false);
    }
  };
  useHotkeys("n", () => {
    if (newButtonRef.current) {
      newButtonRef.current.click();
    }
  });

  console.log(filterData, "fgdsdfdsfdsfdsfsdfd");

  const defaultPermissionFn = () => {};
  const filterPopupRef = useRef(null);
  const handleSelectChange = (event) => {
    setFilterData({ ...filterData, selectColumn: event?.value });
  };
  const searchRef = useRef();
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        showFilter &&
        filterPopupRef.current &&
        !filterPopupRef.current.contains(event.target)
      ) {
        filterFn();
      }
    };
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [filterFn, showFilter]);
  const [isFocused, setIsFocused] = useState(false);

  const debouncedFetchData = useCallback(
    debounce((inputValue) => {
      setFilterData((prev) => ({ ...prev, inputValue }));
      paginationProps.setCurrentPage(1);
    }, 500), // 500ms delay
    []
  );
  const handleChange = (e) => {
    const trimmedValue = e.target.value;
    // const cleanedValue = trimmedValue.replace(/[^a-zA-Z0-9 ]/g, "");

    setSearchTerm(trimmedValue); // Instant UI update
    debouncedFetchData(trimmedValue); // Delayed API call
  };

  // Date validation functions
  const handleFromDateChange = (date) => {
    const newFilterData = { ...filterData, from: date };

    // If both dates exist and from date is after to date, clear to date
    if (date && filterData.to && new Date(date) > new Date(filterData.to)) {
      newFilterData.to = "";
    }

    setFilterData(newFilterData);
    paginationProps.setCurrentPage(1);
  };

  const handleToDateChange = (date) => {
    // Don't allow to date selection if from date is not selected
    if (!filterData.from) {
      // Optionally show a warning or just return without setting
      return;
    }

    // Don't allow to date to be before from date
    if (date && new Date(date) < new Date(filterData.from)) {
      return;
    }

    setFilterData({ ...filterData, to: date });
    paginationProps.setCurrentPage(1);
  };

  return (
    <>
      <LoadingOverlay isLoading={grnSyncLoading} />
      {filterSec ? (
        <div className="flex items-center flex-wrap justify-between px-[24px] ">
          <div className="py-[16px]">
            <div
              style={{ maxWidth: "30rem", height: "32px" }}
              className={`w-full  flex items-center border-radius bg-[var(--head-input-bg-color)]    ${
                isFocused
                  ? "border border-[var(--head-input-focus-border-color)] "
                  : "border border-[var(--head-input-border-color)] "
              }`}
            >
              <Select
                className="border-0 bg-[var(--head-input-bg-color)] z-50 text-[var(--head-input-fg-color)] text-[length:--head-input-font-size] font-[var(--head-input-font-weight)] placeholder:text-[var(--head-input-placeholder-color)] placeholder:text-[length:--head-input-font-size] placeholder:font-[var(--head-input-place-font-weight)]"
                // menuPortalTarget={document.body}
                styles={customStyles}
                value={
                  filterData?.selectColumn
                    ? (() => {
                        const allColumns = [
                          ...(tableHeading ?? []),
                          ...(extraFilters ?? []),
                        ];
                        const found = allColumns.find(
                          (item) => item?.value === filterData?.selectColumn
                        );
                        return found
                          ? {
                              value: found.value,
                              label: capitalizeWords(found.label),
                            }
                          : null;
                      })()
                    : null
                }
                onChange={(e) => {
                  handleSelectChange(e);
                  setIsFocused(true);
                  if (searchRef && searchRef?.current) {
                    searchRef?.current?.focus();
                  }
                }}
                options={[
                  ...tableHeading
                    ?.filter((item) => item?.column)
                    ?.map((item) => ({
                      ...item,
                      label: capitalizeWords(item?.label),
                    })),
                  ...(extraFilters ?? []),
                ]}
                placeholder="Select Column"
                isSearchable={false}
              />
              <div
                className={`h-full w-0.5 ${
                  isFocused
                    ? "border-r border-r-[var(--head-input-focus-border-color)] "
                    : "border-r-[var(--head-input-border-color)] border-r"
                }`}
              ></div>{" "}
              <input
                maxLength={50}
                ref={searchRef}
                autoFocus={true}
                onBlur={() => setIsFocused(false)}
                onFocus={() => setIsFocused(true)}
                placeholder={`${placeholder}`}
                className="text-[var(--head-input-fg-color)] bg-[var(--head-input-bg-color)] text-[length:--head-input-font-size] font-[var(--head-input-font-weight)] w-full rounded-md  h-full placeholder:text-[var(--head-input-placeholder-color)] placeholder:text-[length:--head-input-font-size] placeholder:font-[var(--head-input-place-font-weight)] px-[8px] focus_outline__none"
                type="text"
                // value={filterData?.inputValue}
                value={searchTerm}
                onChange={handleChange}
              />
              <span className="pr-2">
                {/* <img
                  style={{
                    height: "16px",
                    width: "16px",
                  }}
                  src={search}
                  alt="search icon"
                /> */}
                <SearchIcon />
              </span>
            </div>
          </div>

          <div className={"flex items-center gap-3 py-[16px]"}>
            {" "}
            {beforeDateSlot}
            {date && (
              <div
                style={{
                  width: "fit-content",
                  height: "32px",
                }}
                className=" flex items-center gap-2"
              >
                <>
                  {" "}
                  <DatePickerInput
                    placeholder="From Date"
                    onChange={handleFromDateChange}
                    value={filterData?.from}
                    maxDate={filterData?.to}
                  />
                  <DatePickerInput
                    placeholder="To Date"
                    onChange={handleToDateChange}
                    value={filterData?.to}
                    minDate={filterData?.from} // Disable dates before from date
                    disabled={!filterData?.from} // Disable if no from date selected
                  />
                </>
              </div>
            )}
            {fetchColumn && isLocalhost && (
              <div className="flex items-center gap-2">
                <input
                  type="text"
                  value={soitId}
                  onChange={(e) => setSoitId(e.target.value)}
                  placeholder="SOIT ID"
                  style={{ height: "32px" }}
                  className="px-[8px] border border-[var(--head-input-border-color)] focus:border-[var(--head-input-focus-border-color)] border-radius bg-[var(--head-input-bg-color)] text-[var(--head-input-fg-color)] text-[length:--head-input-font-size] font-[var(--head-input-font-weight)] placeholder:text-[var(--head-input-placeholder-color)] placeholder:text-[length:--head-input-font-size] placeholder:font-[var(--head-input-place-font-weight)] focus_outline__none"
                />
                <AddButton
                  prefixIcon={false}
                  isDisabled={!soitId?.trim() || grnSyncLoading}
                  loading={grnSyncLoading}
                  className={`flex justify-center items-center h-[32px] px-[12px] gap-[8px] border-radius whitespace-nowrap transition duration-300 ease-in-out text-[length:--primary-button-font-size] font-[var(--primary-button-font-weight)] ${
                    !soitId?.trim() || grnSyncLoading
                      ? "bg-[var(--header-button-disabled-bg-color)] text-[var(--header-button-disabled-fg-color)] cursor-not-allowed"
                      : "bg-[var(--primary-button-bg-color)] text-[var(--primary-button-fg-color)] hover:bg-[var(--primary-button-hover-color)] cursor-pointer"
                  }`}
                  onclkFn={handleGrnSync}
                  text="Save"
                  spinnerClass="h-4 w-4 border-t-2 border-[var(--primary-button-fg-color)]"
                />
              </div>
            )}
            {filter && (
              <div ref={filterPopupRef} className="relative">
                <AddButton
                  className="flex items-center px-[12px] h-[32px] whitespace-nowrap border-radius  gap-[8px] bg-[var(--header-button-bg-color)]  cursor-pointer text-[var(--header-button-fg-color)] border border-[var(--header-button-border-color)] hover:bg-[var(--header-button-hover-color)]"
                  icon={<FilterIcon />}
                  onclkFn={filterFn}
                  text={filterText}
                />
                {filterBy}
              </div>
            )}
            <AddButton
              isDisabled={
                JSON.stringify(filterData) === JSON.stringify(initialFilter)
              }
              icon={
                <X
                  size={18}
                  fill={
                    JSON.stringify(filterData) === JSON.stringify(initialFilter)
                      ? "var(--header-button-disabled-fg-color)"
                      : "var(--header-button-fg-color)"
                  }
                />
              }
              className={` h-[32px]  text-[length:--head-button-font-size] font-[var(--head-button-font-weight)] whitespace-nowrap  border-radius  flex items-center  gap-[8px] px-[12px] ${
                JSON.stringify(filterData) === JSON.stringify(initialFilter)
                  ? "bg-[var(--header-button-disabled-bg-color)] cursor-not-allowed  text-[var(--header-button-disabled-fg-color)]"
                  : " bg-[var(--header-button-bg-color)]  cursor-pointer text-[var(--header-button-fg-color)] border border-[var(--header-button-border-color)] "
              }`}
              onclkFn={() => {
                setFilterData(initialFilter);
                paginationProps.setCurrentPage(1);
                if (searchRef && searchRef?.current) {
                  searchRef?.current?.focus();
                }
                setSearchTerm(""); // Clear search term
              }}
              text="Clear All"
            />
            {invoiceItems?.length > 0 && (
              <SelectOption options={options} handleSelect={handleSelect} />
            )}
            {(permissionFn || defaultPermissionFn)(module)?.create && list && (
              <AddButton
                ref={newButtonRef}
                icon={
                  <PlusIcon size={18} fill="var(--primary-button-fg-color)" />
                }
                className="border-radius hover:bg-[var(--primary-button-hover-color)] flex justify-center gap-[8px] h-[32px] px-[12px]  items-center   whitespace-nowrap   transition duration-300 ease-in-out   text-[length:--primary-button-font-size] font-[var(--primary-button-font-weight)] bg-[var(--primary-button-bg-color)]  cursor-pointer text-[var(--primary-button-fg-color)]"
                onclkFn={onclkFn}
                text={
                  <span>
                    {newBtnTxt}
                    <span className="opacity-50"> (N)</span>
                  </span>
                }
              />
            )}
            {addNew && newComponet}
            {importCsv && (
              <AddButton
                icon={
                  <img
                    alt="Import CSV"
                    src={excelImg}
                    width={"14px"}
                    height={"14px"}
                  />
                }
                className="border-radius hover:bg-[var(--header-button-hover-color)] flex justify-center gap-[8px] h-[32px] px-[12px]  items-center   whitespace-nowrap   transition duration-300 ease-in-out   text-[length:--head-button-font-size] font-[var(--head-button-font-weight)]   cursor-pointer text-[var(--header-button-fg-color)]  bg-[var(--header-button-bg-color)] border border-[var(--success-color)]"
                onclkFn={onclkCSV}
                text={<span>Import CSV</span>}
              />
            )}
            {importCsv && (
              <AddButton
                icon={
                  <DownloadIcon
                    width="14px"
                    height="14px"
                    fill="var(--success-color)"
                  />
                }
                className="border-radius hover:bg-[var(--header-button-hover-color)] flex justify-center gap-[8px] h-[32px] px-[12px]  items-center   whitespace-nowrap   transition duration-300 ease-in-out   text-[length:--head-button-font-size] font-[var(--head-button-font-weight)]   cursor-pointer text-[var(--header-button-fg-color)]  bg-[var(--header-button-bg-color)] border border-[var(--success-color)]"
                onclkFn={onclkCscDown}
              />
            )}
          </div>
        </div>
      ) : (
        <div className="w-full flex justify-end px-[24px] py-[16px]">
          <></>
          {(permissionFn || defaultPermissionFn)(module)?.create && list && (
            <AddButton
              icon={
                <PlusIcon size={18} fill="var(--primary-button-fg-color)" />
              }
              className="border-radius hover:bg-[var(--primary-button-hover-color)] flex justify-center gap-[8px] h-[32px] px-[12px]  items-center   whitespace-nowrap   transition duration-300 ease-in-out   text-[length:--primary-button-font-size] font-[var(--primary-button-font-weight)] bg-[var(--primary-button-bg-color)]  cursor-pointer text-[var(--primary-button-fg-color)]"
              onclkFn={onclkFn}
              text={
                <span>
                  {newBtnTxt}
                  <span className="opacity-50"> (N)</span>
                </span>
              }
            />
          )}
        </div>
      )}
    </>
  );
};

export default FilterSection;
export const customStyles = {
  control: (provided, state) => ({
    ...provided,
    // fontSize: "12px",
    fontWeight: "600",
    zIndex: 99,
    backgroundColor: "var(--head-input-bg-color)",
    color: "#344054",
    width: "13rem",
    minHeight: "25px",
    boxShadow: "none", // Remove box shadow
    border: "none",
    borderRadius: "6px",
  }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      color: "var(--head-input-placeholder-color)",
      // fontFamily: "Inter,sans-serif",
      fontSize: "var(--head-input-font-size)",
      fontWeight: "var(--head-input-place-font-weight)",
      // opacity: "1",
      // position: "absolute",
      // whiteSpace: "nowrap",
    };
  },

  indicatorSeparator: (provided, state) => ({
    ...provided,
    display: "none", // Hide indicator separator
  }),
  singleValue: (base) => ({
    ...base,
    fontWeight: "400",
    color: "var(--head-input-fg-color)",
    // fontSize: "12px",
  }),
  option: (provided, state) => {
    return {
      ...provided,
      ...(state.data.color ? { color: state.data.color } : { color: "black" }),
      backgroundColor: state.isSelected ? "#e5ecffb2" : null,
      borderBottom: "1px solid #F5F5F5",
      fontSize: "12px",
      zIndex: 99,
      fontFamily: "Inter,sans-serif",
      "&:hover": {
        backgroundColor: state.isFocused ? "#0000002E" : "#0000002E",
      },
    };
  },

  indicatorContainer: (provided) => ({
    ...provided,
    padding: 0, // Remove padding
  }),
  dropdownIndicator: (provided) => ({
    ...provided,

    fontSize: "14px",
    padding: 0, // Removes padding from the dropdown icon
    fontWeight: "400",
  }),
};

// import React, { useCallback, useEffect, useRef, useState } from "react";
// import Select from "react-select";
// import FilterIcon from "../../assets/icons/filter-icon";
// import AddButton from "../buttons/button";
// import { capitalizeWords } from "../helper-components/helper-function";
// import DatePickerInput from "../forms/date-picker";
// import { debounce } from "lodash";
// import SelectOption from "../helper-components/select-option";
// import SearchIcon from "../../assets/icons/search-icon";
// import excelImg from "../../assets/icons/excel.png";
// import DownloadIcon from "../../assets/icons/download-icon";
// import { PlusIcon, X } from "lucide-react";
// import { useHotkeys } from "react-hotkeys-hook";

// const FilterSection = ({
//   filterData,
//   setFilterData,
//   initialFilter = {},
//   placeholder,
//   filterFn = () => {},
//   tableHeading,
//   filterBy,
//   showFilter,
//   paginationProps,
//   filterText = "Filter",
//   date = true,
//   filter,
//   permissionFn,
//   module,
//   onclkFn,
//   list,
//   filterSec = true,
//   newBtnTxt = "New",
//   // SUB TABLE
//   invoiceItems,
//   handleSelect = () => {},
//   options = [],
//   importCsv = false,
//   onclkCscDown = () => {},
//   onclkCSV = () => {},
// }) => {
//   const [searchTerm, setSearchTerm] = useState(filterData?.inputValue || "");
//   const newButtonRef = useRef();
//   useHotkeys("n", () => {
//     if (newButtonRef.current) {
//       newButtonRef.current.click();
//     }
//   });

//   console.log(filterData, "fgdsdfdsfdsfdsfsdfd");

//   const defaultPermissionFn = () => {};
//   const filterPopupRef = useRef(null);
//   const handleSelectChange = (event) => {
//     setFilterData({ ...filterData, selectColumn: event?.value });
//   };
//   const searchRef = useRef();
//   useEffect(() => {
//     const handleOutsideClick = (event) => {
//       if (
//         showFilter &&
//         filterPopupRef.current &&
//         !filterPopupRef.current.contains(event.target)
//       ) {
//         filterFn();
//       }
//     };
//     document.addEventListener("click", handleOutsideClick);
//     return () => {
//       document.removeEventListener("click", handleOutsideClick);
//     };
//   }, [filterFn, showFilter]);
//   const [isFocused, setIsFocused] = useState(false);

//   const debouncedFetchData = useCallback(
//     debounce((inputValue) => {
//       setFilterData((prev) => ({ ...prev, inputValue }));
//       paginationProps.setCurrentPage(1);
//     }, 500), // 500ms delay
//     []
//   );
//   const handleChange = (e) => {
//     const trimmedValue = e.target.value;
//     setSearchTerm(trimmedValue); // Instant UI update
//     debouncedFetchData(trimmedValue); // Delayed API call
//   };
//   return (
//     <>
//       {filterSec ? (
//         <div className="flex items-center flex-wrap justify-between px-[24px] ">
//           <div className="py-[16px]">
//             <div
//               style={{ maxWidth: "30rem", height: "32px" }}
//               className={`w-full  flex items-center border-radius bg-[var(--head-input-bg-color)]    ${
//                 isFocused
//                   ? "border border-[var(--head-input-focus-border-color)] "
//                   : "border border-[var(--head-input-border-color)] "
//               }`}
//             >
//               <Select
//                 className="border-0 bg-[var(--head-input-bg-color)] z-50 text-[var(--head-input-fg-color)] text-[length:--head-input-font-size] font-[var(--head-input-font-weight)] placeholder:text-[var(--head-input-placeholder-color)] placeholder:text-[length:--head-input-font-size] placeholder:font-[var(--head-input-place-font-weight)]"
//                 // menuPortalTarget={document.body}
//                 styles={customStyles}
//                 value={
//                   filterData?.selectColumn
//                     ? tableHeading?.find(
//                         (item) => item?.value === filterData?.selectColumn
//                       )
//                       ? {
//                           value: tableHeading?.find(
//                             (item) => item?.value === filterData?.selectColumn
//                           )?.value,
//                           label: capitalizeWords(
//                             tableHeading?.find(
//                               (item) => item?.value === filterData?.selectColumn
//                             )?.label
//                           ),
//                           // Capitalize first letter of each word
//                         }
//                       : null
//                     : null
//                 }
//                 onChange={(e) => {
//                   handleSelectChange(e);
//                   setIsFocused(true);
//                   if (searchRef && searchRef?.current) {
//                     searchRef?.current?.focus();
//                   }
//                 }}
//                 options={tableHeading
//                   ?.filter((item) => item?.column)
//                   ?.map((item) => ({
//                     ...item,
//                     label: capitalizeWords(item?.label),
//                     // Capitalize first letter
//                   }))}
//                 placeholder="Select Column"
//                 isSearchable={false}
//               />
//               <div
//                 className={`h-full w-0.5 ${
//                   isFocused
//                     ? "border-r border-r-[var(--head-input-focus-border-color)] "
//                     : "border-r-[var(--head-input-border-color)] border-r"
//                 }`}
//               ></div>{" "}
//               <input
//                 ref={searchRef}
//                 autoFocus={true}
//                 onBlur={() => setIsFocused(false)}
//                 onFocus={() => setIsFocused(true)}
//                 placeholder={`${placeholder}`}
//                 className="text-[var(--head-input-fg-color)] bg-[var(--head-input-bg-color)] text-[length:--head-input-font-size] font-[var(--head-input-font-weight)] w-full rounded-md  h-full placeholder:text-[var(--head-input-placeholder-color)] placeholder:text-[length:--head-input-font-size] placeholder:font-[var(--head-input-place-font-weight)] px-[8px] focus_outline__none"
//                 type="text"
//                 // value={filterData?.inputValue}
//                 value={searchTerm}
//                 onChange={handleChange}
//               />
//               <span className="pr-2">
//                 {/* <img
//                   style={{
//                     height: "16px",
//                     width: "16px",
//                   }}
//                   src={search}
//                   alt="search icon"
//                 /> */}
//                 <SearchIcon />
//               </span>
//             </div>
//           </div>

//           <div className={"flex items-center gap-3 py-[16px]"}>
//             {" "}
//             {date && (
//               <div
//                 style={{
//                   width: "fit-content",
//                   height: "32px",
//                 }}
//                 className=" flex items-center gap-2"
//               >
//                 <>
//                   {" "}
//                   <DatePickerInput
//                     placeholder="From Date"
//                     onChange={(date) => {
//                       setFilterData({ ...filterData, from: date });
//                       paginationProps.setCurrentPage(1);
//                     }}
//                     value={filterData?.from}
//                   />
//                   <DatePickerInput
//                     placeholder="To Date"
//                     onChange={(date) => {
//                       setFilterData({ ...filterData, to: date });
//                       paginationProps.setCurrentPage(1);
//                     }}
//                     value={filterData?.to}
//                   />
//                 </>
//               </div>
//             )}
//             {filter && (
//               <div ref={filterPopupRef} className="relative">
//                 <AddButton
//                   className="flex items-center px-[12px] h-[32px] whitespace-nowrap border-radius  gap-[8px] bg-[var(--header-button-bg-color)]  cursor-pointer text-[var(--header-button-fg-color)] border border-[var(--header-button-border-color)] hover:bg-[var(--header-button-hover-color)]"
//                   icon={<FilterIcon />}
//                   onclkFn={filterFn}
//                   text={filterText}
//                 />
//                 {filterBy}
//               </div>
//             )}
//             <AddButton
//               isDisabled={
//                 JSON.stringify(filterData) === JSON.stringify(initialFilter)
//               }
//               icon={
//                 <X
//                   size={18}
//                   fill={
//                     JSON.stringify(filterData) === JSON.stringify(initialFilter)
//                       ? "var(--header-button-disabled-fg-color)"
//                       : "var(--header-button-fg-color)"
//                   }
//                 />
//               }
//               className={` h-[32px]  text-[length:--head-button-font-size] font-[var(--head-button-font-weight)] whitespace-nowrap  border-radius  flex items-center  gap-[8px] px-[12px] ${
//                 JSON.stringify(filterData) === JSON.stringify(initialFilter)
//                   ? "bg-[var(--header-button-disabled-bg-color)] cursor-not-allowed  text-[var(--header-button-disabled-fg-color)]"
//                   : " bg-[var(--header-button-bg-color)]  cursor-pointer text-[var(--header-button-fg-color)] border border-[var(--header-button-border-color)] "
//               }`}
//               onclkFn={() => {
//                 setFilterData(initialFilter);
//                 paginationProps.setCurrentPage(1);
//                 if (searchRef && searchRef?.current) {
//                   searchRef?.current?.focus();
//                 }
//                 setSearchTerm(""); // Clear search term
//               }}
//               text="Clear All"
//             />
//             {invoiceItems?.length > 0 && (
//               <SelectOption options={options} handleSelect={handleSelect} />
//             )}
//             {(permissionFn || defaultPermissionFn)(module)?.create && list && (
//               <AddButton
//                 ref={newButtonRef}
//                 icon={
//                   <PlusIcon size={18} fill="var(--primary-button-fg-color)" />
//                 }
//                 className="border-radius hover:bg-[var(--primary-button-hover-color)] flex justify-center gap-[8px] h-[32px] px-[12px]  items-center   whitespace-nowrap   transition duration-300 ease-in-out   text-[length:--primary-button-font-size] font-[var(--primary-button-font-weight)] bg-[var(--primary-button-bg-color)]  cursor-pointer text-[var(--primary-button-fg-color)]"
//                 onclkFn={onclkFn}
//                 text={
//                   <span>
//                     {newBtnTxt}
//                     <span className="opacity-50"> (N)</span>
//                   </span>
//                 }
//               />
//             )}
//             {importCsv && (
//               <AddButton
//                 icon={
//                   <img
//                     alt="Import CSV"
//                     src={excelImg}
//                     width={"14px"}
//                     height={"14px"}
//                   />
//                 }
//                 className="border-radius hover:bg-[var(--header-button-hover-color)] flex justify-center gap-[8px] h-[32px] px-[12px]  items-center   whitespace-nowrap   transition duration-300 ease-in-out   text-[length:--head-button-font-size] font-[var(--head-button-font-weight)]   cursor-pointer text-[var(--header-button-fg-color)]  bg-[var(--header-button-bg-color)] border border-[var(--success-color)]"
//                 onclkFn={onclkCSV}
//                 text={<span>Import CSV</span>}
//               />
//             )}
//             {importCsv && (
//               <AddButton
//                 icon={
//                   <DownloadIcon
//                     width="14px"
//                     height="14px"
//                     fill="var(--success-color)"
//                   />
//                 }
//                 className="border-radius hover:bg-[var(--header-button-hover-color)] flex justify-center gap-[8px] h-[32px] px-[12px]  items-center   whitespace-nowrap   transition duration-300 ease-in-out   text-[length:--head-button-font-size] font-[var(--head-button-font-weight)]   cursor-pointer text-[var(--header-button-fg-color)]  bg-[var(--header-button-bg-color)] border border-[var(--success-color)]"
//                 onclkFn={onclkCscDown}
//               />
//             )}
//           </div>
//         </div>
//       ) : (
//         <div className="w-full flex justify-end px-[24px] py-[16px]">
//           <></>
//           {(permissionFn || defaultPermissionFn)(module)?.create && list && (
//             <AddButton
//               icon={
//                 <PlusIcon size={18} fill="var(--primary-button-fg-color)" />
//               }
//               className="border-radius hover:bg-[var(--primary-button-hover-color)] flex justify-center gap-[8px] h-[32px] px-[12px]  items-center   whitespace-nowrap   transition duration-300 ease-in-out   text-[length:--primary-button-font-size] font-[var(--primary-button-font-weight)] bg-[var(--primary-button-bg-color)]  cursor-pointer text-[var(--primary-button-fg-color)]"
//               onclkFn={onclkFn}
//               text={
//                 <span>
//                   {newBtnTxt}
//                   <span className="opacity-50"> (N)</span>
//                 </span>
//               }
//             />
//           )}
//         </div>
//       )}
//     </>
//   );
// };

// export default FilterSection;
// export const customStyles = {
//   control: (provided, state) => ({
//     ...provided,
//     // fontSize: "12px",
//     fontWeight: "600",
//     zIndex: 99,
//     backgroundColor: "var(--head-input-bg-color)",
//     color: "#344054",
//     width: "13rem",
//     minHeight: "25px",
//     boxShadow: "none", // Remove box shadow
//     border: "none",
//     borderRadius: "6px",
//   }),
//   placeholder: (defaultStyles) => {
//     return {
//       ...defaultStyles,
//       color: "var(--head-input-placeholder-color)",
//       // fontFamily: "Inter,sans-serif",
//       fontSize: "var(--head-input-font-size)",
//       fontWeight: "var(--head-input-place-font-weight)",
//       // opacity: "1",
//       // position: "absolute",
//       // whiteSpace: "nowrap",
//     };
//   },

//   indicatorSeparator: (provided, state) => ({
//     ...provided,
//     display: "none", // Hide indicator separator
//   }),
//   singleValue: (base) => ({
//     ...base,
//     fontWeight: "400",
//     color: "var(--head-input-fg-color)",
//     // fontSize: "12px",
//   }),
//   option: (provided, state) => {
//     return {
//       ...provided,
//       ...(state.data.color ? { color: state.data.color } : { color: "black" }),
//       backgroundColor: state.isSelected ? "#e5ecffb2" : null,
//       borderBottom: "1px solid #F5F5F5",
//       fontSize: "12px",
//       zIndex: 99,
//       fontFamily: "Inter,sans-serif",
//       "&:hover": {
//         backgroundColor: state.isFocused ? "#0000002E" : "#0000002E",
//       },
//     };
//   },

//   indicatorContainer: (provided) => ({
//     ...provided,
//     padding: 0, // Remove padding
//   }),
//   dropdownIndicator: (provided) => ({
//     ...provided,

//     fontSize: "14px",
//     padding: 0, // Removes padding from the dropdown icon
//     fontWeight: "400",
//   }),
// };
